import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import numeral from 'numeral';
import zipcelx from 'zipcelx';
import { getUtlParams, isMaster } from '../statisticsHelpers';
import CustomControl from '../../CustomControl/CustomControl';
import {
  getStringOrSingleArrayValue,
  getZoneOffsetByName,
  getToFixedParams,
  _toFixed,
  isString,
} from '../../../utils/utils';

import { StatisticsExportView } from '../index';
import Icon from '../../Icon/Icon';
const XMLFieldNames = {
  3: 'date',
  4: 'title',
  5: 'stream',
  6: 'title',
  7: 'site',
  8: 'title',
  9: 'title',
  11: 'title',
  13: 'title',
  15: 'SubID1',
  16: 'SubID2',
  17: 'SubID3',
  18: 'SubID4',
  19: 'SubID5',
  20: 'landing',
  24: 'clicks',
  25: 'hits',
  124: 'epc',
  123: 'cr',
  127: 'leads',
  137: 'bills',
  27: 'leadsApproved',
  28: 'leadsPending',
  29: 'leadsDeclined',
  30: 'leadsDeleted',
  126: 'summ',
  31: 'summApproved',
  32: 'summPending',
  33: 'summDeclined',
  35: 'subid',
  201: 'clickDate',
  202: 'leadDate',
  203: ['advCampaignName', 'action'],
  204: ['geo', 'ip', 'refererClick'],
  205: ['status'],
};

const complexFields = ['203', '204', '205'];
const conversionFields = ['127', '27', '36', '28', '29', '30'];
const numericTypes = ['int', 'money'];

class StatisticsExport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      sortedKeys: [],
    };

    this.$el = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { stats } = nextProps;

    if (stats && stats.length) {
      const data = Object.keys(stats[0]).reduce((data, field) => {
        const config = this.getConfig(field);
        if (config && XMLFieldNames[field]) {
          let title;

          if (conversionFields.includes(field)) {
            title = this.renderConversionFieldsTitle(field, config);
          } else {
            title = config.title;
          }

          return [
            ...data,
            {
              id: field,
              title,
              checked: true,
            },
          ];
        }
        return data;
      }, []);
      const { config } = this.props;
      this.setState(() => ({
        data: this.splitComplexField(this.sortData(data, config)),
        sortedKeys: this.sortKeys(stats[0], config),
      }));
    }
  }

  /**
   * Remove null values
   *
   * @param {array} stats Statistics
   * @param {number} currency Currency
   *
   * @return {array} Filtered statistics
   */
  removeEmptyStats = (stats, currency) => {
    const statistics = [];

    for (let i = 0, len = stats.length; i < len; i++) {
      let row = stats[i];

      if (!row || typeof row !== 'object' || !Array.isArray(Object.values(row)[0])) {
        continue;
      }

      let firstCell = Object.values(row)[0][currency];

      if (firstCell === null) {
        continue;
      }

      statistics.push(row);
    }

    return statistics;
  };

  renderConversionFieldsTitle = (field, config) => {
    switch (field) {
      case '127':
        return config.group;
      case '30':
        return config.title;
      default:
        return config.group + ' ' + config.title;
    }
  };

  sortData = (arr, config) =>
    arr.sort((a, b) => {
      const indexA = config.findIndex((elem) => elem.id === a.id * 1);
      const indexB = config.findIndex((elem) => elem.id === b.id * 1);

      return indexA - indexB;
    });

  sortKeys = (stats, config) =>
    Object.keys(stats).sort((a, b) => {
      const indexA = config.findIndex((elem) => elem.id === a * 1);
      const indexB = config.findIndex((elem) => elem.id === b * 1);

      return indexA - indexB;
    });

  splitComplexField = (arr) => {
    const newArr = [];
    arr.forEach((item) => {
      if (complexFields.includes(item.id)) {
        const splitted = item.title.split(' / ');
        return splitted.forEach((splittedItem, index) => {
          if ((item.id === '204' || item.id === '205') && index + 1 === splitted.length) return;
          newArr.push({
            id: item.id + index,
            title: splittedItem,
            checked: true,
          });
        });
      }

      newArr.push(item);
    });

    return newArr;
  };

  checkFieldExporting = (field) => {
    const { data } = this.state;

    let formattedField = field;

    if (complexFields.includes(field)) {
      formattedField += '0';
    }

    const dataField = data.find((elem) => elem.id === formattedField);
  };

  handleExportCSV = () => {
    const { stats, currency } = this.props;
    const formattedStats = this.removeEmptyStats(stats, currency);

    let csvString = this.renderHeaderCSV();

    formattedStats.forEach((stat) => {
      const row = this.renderRowCSV(stat);
      csvString += '\n' + row;
    });

    this.downloadFile(csvString, 'csv');
  };

  renderHeaderCSV = () => {
    const { data } = this.state;

    const headerArray = [];

    Object.keys(data).forEach((field) => {
      if (data[field].checked) {
        const line = data[field].title;
        headerArray.push(line);
      }
    });

    return headerArray.join(',');
  };

  renderRowCSV = (stat) => {
    const { currency } = this.props;
    const { data, sortedKeys } = this.state;
    let rowArray = [];
    sortedKeys.forEach((field) => {
      const config = this.getConfig(field);
      if (complexFields.includes(field)) {
        let fieldsCount = config.title.split(' / ').length;
        if (field === '204' || field === '205') {
          fieldsCount -= 1;
        }
        for (let i = 0; i < fieldsCount; i++) {
          const dataField = data.find((elem) => elem.id === field + i);
          if (XMLFieldNames[field][i] && dataField && dataField.checked) {
            if (config) {
              let value = this.formatValue(stat[field][currency], config.type, field);
              rowArray.push(value[i]);
            }
          }
        }
      } else {
        const dataField = data.find((elem) => elem.id === field);
        if (XMLFieldNames[field] && dataField && dataField.checked) {
          if (config) {
            let value = this.formatValue(stat[field][currency], config.type, field);
            if (Array.isArray(value)) {
              value = value.filter((el) => el !== '').join(', ');
            }
            rowArray.push(value);
          }
        }
      }
    });

    return rowArray.join(',');
  };

  handleExportXLS = () => {
    const { stats, type, currency } = this.props;
    const formattedStats = this.removeEmptyStats(stats, currency);
    const table = [];

    formattedStats.forEach((stat) => {
      const row = this.renderRowXLS(stat);
      table.push(row);
    });

    const filename = `offerrum_statistics_${type}`;

    const config = {
      filename,
      sheet: {
        data: [this.renderTableHeadXLS(), ...table],
      },
    };

    zipcelx(config);
  };

  renderHeadXLS = () => {
    const head = document.createElement('head');
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Type');
    meta.setAttribute('content', 'text/html; charset=UTF-8');
    head.appendChild(meta);

    return head;
  };

  renderTableHeadXLS = () => {
    const { data } = this.state;
    const row = [];

    Object.keys(data).forEach((field) => {
      if (data[field].checked) {
        const cell = {
          value: data[field].title,
          type: 'string',
        };
        row.push(cell);
      }
    });

    return row;
  };

  renderRowXLS = (stat) => {
    const { currency } = this.props;
    const { data, sortedKeys } = this.state;

    const row = [];

    sortedKeys.forEach((field) => {
      const config = this.getConfig(field);

      if (complexFields.includes(field)) {
        let fieldsCount = config.title.split(' / ').length;
        if (field === '204' || field === '205') {
          fieldsCount -= 1;
        }
        for (let i = 0; i < fieldsCount; i++) {
          const dataField = data.find((elem) => elem.id === field + i);
          if (XMLFieldNames[field][i] && dataField && dataField.checked) {
            if (config) {
              let value = this.formatValue(stat[field][currency], config.type, field);
              const type = numericTypes.includes(config.type) ? 'number' : 'string';
              const cell = {
                value: value[i],
                type,
              };
              row.push(cell);
            }
          }
        }
      } else {
        const dataField = data.find((elem) => elem.id === field);
        if (XMLFieldNames[field] && dataField && dataField.checked) {
          if (config) {
            let value = this.formatValue(stat[field][currency], config.type, field);
            const type = numericTypes.includes(config.type) ? 'number' : 'string';
            const cell = {
              value,
              type,
            };
            row.push(cell);
          }
        }
      }
    });

    return row;
  };

  handleExportXML = () => {
    const xmlDoc = this.convertToXML();
    const serialized = new XMLSerializer().serializeToString(xmlDoc);

    const prolog = '<?xml version="1.0" encoding="utf-8"?>';
    const newXmlStr = prolog + serialized;

    this.downloadFile(newXmlStr, 'xml');
  };

  convertToXML = () => {
    const { stats, total, type, currency } = this.props;
    const { data, sortedKeys } = this.state;
    const formattedStats = this.removeEmptyStats(stats, currency);
    const xmlDoc = document.implementation.createDocument('', '', null);
    const statistics = xmlDoc.createElement('statistics');
    const items = xmlDoc.createElement('items');

    formattedStats.forEach((stat) => {
      const item = xmlDoc.createElement('item');
      sortedKeys.forEach((field, index) => {
        const dataField = data.find((elem) => elem.id === field);
        if (
          (XMLFieldNames[field] && dataField && dataField.checked) ||
          complexFields.includes(field)
        ) {
          const fieldName = index === 0 && this.checkTitle(type) ? 'title' : XMLFieldNames[field];
          const config = this.getConfig(field);

          const value = this.formatValue(stat[field][currency], config.type, field);
          if (Array.isArray(value)) {
            value.forEach((subField, index) => {
              const fieldName = XMLFieldNames[field][index];
              const XMLField = xmlDoc.createElement(fieldName);
              if (
                config.type !== 'int' &&
                config.type !== 'money' &&
                config.type !== 'status_info'
              ) {
                XMLField.innerHTML = this.toCDATA(subField);
              } else {
                XMLField.innerHTML = subField;
              }
              item.appendChild(XMLField);
            });
          } else {
            const XMLField = xmlDoc.createElement(fieldName);
            if (config.type !== 'int' && config.type !== 'money' && config.type !== 'status_info') {
              XMLField.innerHTML = this.toCDATA(value);
            } else {
              XMLField.innerHTML = value;
            }

            item.appendChild(XMLField);
          }
        }
      });
      items.appendChild(item);
    });
    if (total && Object.keys(total).length) {
      const totalField = xmlDoc.createElement('total');
      sortedKeys.forEach((field, index) => {
        const dataField = data.find((elem) => elem.id === field);
        if (XMLFieldNames[field] && dataField && dataField.checked) {
          const fieldName = index === 0 && this.checkTitle(type) ? 'title' : XMLFieldNames[field];
          const XMLField = xmlDoc.createElement(fieldName);
          const config = this.getConfig(field);
          const value = this.formatValue(total[field]?.[currency], config?.type, field, true);
          if (config?.type !== 'int' && config?.type !== 'money' && config?.type !== 'status_info') {
            XMLField.innerHTML = this.toCDATA(value);
          } else {
            XMLField.innerHTML = value;
          }
          totalField.appendChild(XMLField);
        }
      });
      items.appendChild(totalField);
    }

    statistics.appendChild(items);
    xmlDoc.appendChild(statistics);

    return xmlDoc;
  };

  checkTitle = (type) => !['subs', 'leads', 'pixels'].includes(type);

  downloadFile = (file, fileType) => {
    const downloadLink = document.createElement('a');
    const { type } = this.props;
    const fileName = `offerrum_statistics_${type}.${fileType}`;
    const blob = new Blob([file], { encoding: 'UTF-8', type: `text/${fileType};charset=UTF-8` });
    downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
    downloadLink.setAttribute('download', fileName);
    downloadLink.dataset.downloadurl = [
      `text/${fileType}`,
      downloadLink.download,
      downloadLink.href,
    ].join(':');
    downloadLink.click();
  };

  formatValue = (value, type, statId, isTotal) => {
    const { filters, timeZones, config, countries, dict, offers, flows, sites } = this.props;
    let timeZone = '';
    const tz = filters.timeZone;
    if (tz) {
      timeZone = getZoneOffsetByName(timeZones, tz);
    }
    //TODO: в ad1 money пишется интом, но EPC как float
    switch (type) {
      case 'int':
      case 'money':
        // const intValue = numeral(value).format('0');
        return value;
      case 'date':
        const format = ['201', '202'].includes(statId) ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY';
        return isTotal ? '' : moment.unix(value).utcOffset(timeZone).format(format);
      case 'float':
        const { numFormat, strFormat } = getToFixedParams(config, statId);
        return numeral(_toFixed(value, numFormat)).format(strFormat);
      case 'hours':
        const val = value > 9 ? value : `0${value}`;
        let nextHour = val > 22 ? 0 : Number(val) + 1;
        nextHour = nextHour > 9 ? nextHour : `0${nextHour}`;
        return isTotal ? '' : `${val}:00 - ${nextHour}:00`;
      case 'country_iso':
        const country = countries.find((country) => country.id === value);
        return country && country.title;
      case 'offer_id':
        let offer;

        if (dict['offers'] !== undefined) {
          offer = dict['offers'].find((offer) => offer.id === value);
        }
        if (!offer && offers) {
          offer = offers.find((offer) => offer.id === value);
        }

        return offer && isString(offer.title) && offer.title;
      case 'stream_id':
        let stream =
          dict['flows'] !== undefined && dict['flows'].find((stream) => stream.id === value);
        if (!stream && flows) {
          stream = flows.find(({ id }) => id === value);
        }
        return stream && isString(stream.title) ? stream.title : value;
      case 'brand_id':
        let device;

        if (dict['devices'] !== undefined) {
          device = dict['devices'].find((vendor) => vendor.id === value);
        }

        return device;
      case 'browser_id':
        let browser;

        if (dict['browsers'] !== undefined) {
          browser = dict['browsers'].find((vendor) => vendor.id === value);
        }

        return browser;
      case 'os_id':
        let os;

        if (dict['os'] !== undefined) {
          os = dict['os'].find((vendor) => vendor.id === value);
        }

        return os ? os.title : ``;
      case 'subacc':
        if (value && value.label) {
          return value.label;
        }
        return value;

      case 'offer_pixel':
        let offerValue, pixelValue;
        if (Array.isArray(value)) {
          const [offerId, pixelId] = value;

          if (dict['offers'] !== undefined) {
            offerValue = dict['offers'].find(({ id }) => id === offerId);
          }
          if (!offerValue && offers) {
            offerValue = offers.find(({ id }) => id === offerId);
          }
          if (dict['pixels'] !== undefined) {
            pixelValue = dict['pixels'].find(({ id }) => id === pixelId);
          }
          if (!pixelValue && offers && offers.pixels) {
            pixelValue = offers.pixels.find(({ id }) => id === pixelId);
          }

          offerValue = offerValue ? offerValue.title : offerId;
          pixelValue = pixelValue ? pixelValue.title : pixelId;

          return [offerValue, pixelValue];
        }

        return ['', ''];

      case 'geo_ip_referrer_info':
        let countryString;

        if (Array.isArray(value)) {
          const [countryId, ip, referrer, city] = value;
          countryString = countries.find((country) => country.id === countryId);
          const geo = countryString ? countryString.title + (city ? '; ' + city : '') : 'N/A';

          return [geo, ip, referrer];
        }

        return '';

      case 'status_info':
        return value ? [value[0]] : [''];

      case 'landing_id':
        let land;

        if (dict['landings'] !== undefined) {
          land = dict['landings'].find(({ id }) => id === value);
        }

        return land ? land.title : value;

      case 'site_id':
        const site = sites.find((site) => site.id === value);
        return site && isString(site.title) ? site.title : value;
    }
  };

  toCDATA = (value) => (value ? `<![CDATA[${value}]]>` : ``);

  getConfig = (id) => this.props.config.find((elem) => elem.id == id);

  onChange = ({ target }) => {
    const { name } = target;
    const value = target.checked;

    this.setState((prevState) => ({
      data: prevState.data.map((item, index) => {
        if (index === name * 1) {
          item.checked = value;
        }
        return item;
      }),
    }));
  };

  toggleFieldsState = (bool) => {
    const fields = { ...this.state.data };
    for (let field in fields) {
      fields[field].checked = bool;
    }

    this.setState((prevState) => ({
      ...prevState,
      data: fields,
    }));
  };

  renderExportFields = () => {
    const { data } = this.state;

    return (
      <div className="statistics-export-list-container">
        <FormattedMessage
          tagName="p"
          id="statistics.export.field.title"
          defaultMessage="Fields for export"
        />
        <ul className="statistics-export-list list-unstyled no-margin">
          {Object.keys(data)?.map((field) => {
            return (
              <li className="statistics-export-list-item" key={`statistics-export-${field}`}>
                <CustomControl
                  id={`statistics-export-${field}`}
                  name={field}
                  type="checkbox"
                  className="custom-checkbox-eye"
                  value={field}
                  onChange={this.onChange}
                  checked={data[field]['checked']}
                >
                  {data[field]['title']}
                </CustomControl>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  render() {
    const { hasExportModalOpen, handleHasExportModalToggle } = this.props;
    return (
      <StatisticsExportView
        open={hasExportModalOpen}
        toggle={handleHasExportModalToggle}
        exportFields={this.renderExportFields()}
        $el={this.$el}
        handleExportXLS={this.handleExportXLS}
        handleExportXML={this.handleExportXML}
        handleExportCSV={this.handleExportCSV}
        toggleFieldsState={this.toggleFieldsState}
      />
    );
  }
}

const mapStateToProps = ({ statistics, webmaster, streams, app, slaves }) => {
  const {
    parsedQuery: { timeZone: tz },
  } = getUtlParams();
  const timeZone = tz
    ? tz
    : statistics.filters.timeZone
    ? getStringOrSingleArrayValue(statistics.filters.timeZone)
    : webmaster.profile.timezone;
  const master = isMaster();
  return {
    offers: !master ? webmaster.offers : slaves.offers,
    flows: !master ? streams.streams : slaves.streams.streams,
    sites: !master ? webmaster.sites : slaves.slaveSites,
    filters: { ...statistics.filters, timeZone },
    timeZones: app.globalSettings.timezones,
    countries: app.globalSettings.countries,
    config: statistics.config,
    dict: !master ? statistics.dict : slaves.dict,
  };
};

export default connect(mapStateToProps)(StatisticsExport);
